module.exports = __webpack_public_path__ + "static/Moret-929879dacf9a210f95dd1f9a5def4c48.woff2";